// Product-level feature switches. Flip here, not at call sites, so a
// hidden feature disappears from every entry point at once while its
// code (and existing projects) keep working.

// Sheets creation is hidden for now (user decision 10/08/2026): the flow
// stays functional for existing sheet projects and via direct routes,
// but no new-creation entry point advertises it.
export const SHOW_SHEETS = false;

// PPTX (native master) templates are hidden for now (user decision
// 23/08/2026): existing native projects keep working and the lab stays
// reachable by URL, but no creation surface advertises them.
export const SHOW_PPTX_TEMPLATES = false;
